<template>
  <div class="container">
    <div>
      <el-input
        size="mini"
        style="width: 150px"
        v-model="seachBox"
        placeholder="请输入模块名称"
      ></el-input>
      &nbsp;
      <el-button type="primary" size="mini" @click="moduleuploadDialog = true"
        >上传支付模块</el-button
      >
      &nbsp;
      <el-badge class="mark" :value="modulesListByFilter.length || 0">
        <el-tag type="success" size="mini">总计</el-tag>
      </el-badge>
    </div>
    <vv-table :config="tableConfig" :height="600" :data="modulesListByFilter">
      <template slot-scope="scope" slot="add_date_slot">
        {{ scope.row.add_date | tsToDate }}
      </template>
      <template slot="version_slot">
        -
      </template>
      <template slot-scope="scope" slot="event_slot">
        <!--<el-button type="text" size="mini">更新</el-button>-->
        <el-button
          class="danger-text"
          type="text"
          size="mini"
          @click="deleteRow(scope.row)"
          >删除</el-button
        >
        <el-button type="text" size="mini" @click="downLoad(scope.row)"
          >下载</el-button
        >
        <!--<el-button type="text" size="mini" @click="edit(scope.row)">更新</el-button>-->
        <el-button type="text" size="mini" @click="copy(scope.row)"
          >复制链接</el-button
        >
        <!--<el-button type="text" size="mini" @click="showUsing(scope.row)">查看餐厅</el-button>-->
      </template>
    </vv-table>
    <el-dialog
      title="支付模块上传"
      :visible.sync="moduleuploadDialog"
      width="50%"
    >
      <el-form ref="form" :model="moduleForm" label-width="80px">
        <el-form-item label="模块名称">
          <el-input
            v-model="moduleForm.name"
            placeholder="请输入模块名称"
          ></el-input>
        </el-form-item>
        <el-table-column
          header-align="center"
          align="center"
          label="入口文件"
          prop="start_file_name"
        >
        </el-table-column>
        <el-form-item label="模块选择">
          <el-upload
            class="upload-demo"
            action=""
            :http-request="modelUpload"
            :before-upload="handleBeforeUpload"
            accept="zip"
            :limit="1"
            ref="upload"
          >
            <el-button size="small" type="primary">请选择支付模块zip</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="入口文件">
          <el-col :span="10">
            <el-input
              v-model="moduleForm.start_file_name"
              placeholder="入口文件"
              :disabled="true"
            ></el-input>
          </el-col>
          <el-col :span="10">
            <el-button type="text" @click="changeStartFile">修改</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUpload" size="mini">取 消</el-button>
        <el-button type="primary" @click="confirmUpload" size="mini"
          >确 定</el-button
        >
      </span>
      <el-dialog
        title="提示"
        :visible.sync="selectDialog"
        :append-to-body="true"
        width="30%"
      >
        <span>此zip包有多个.exe文件, 请选择入口文件</span>
        <div v-for="name in exeName" :key="name">
          {{ name }}
          <el-button type="text" size="mini" @click="chooseStartName(name)"
            >选择</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import aliOSSUpload from '@/lib/aliOSSUpload';
import pinyinMatch from 'pinyin-match';
import vvTable from 'vue-virtual-table';
import {apiAddPaymentModule, apiDeletePaymentModules, apiGetAllPaymentModules} from '@/api';
import moment from 'moment';
import md5 from 'js-md5';
import JsZip from 'jszip';
import fileSaver from 'file-saver';

export default {
  name: "paymentModuleAdmin",
  components: { vvTable },
  data() {
    return {
      seachBox: "",
      paymentsList: [],
      exeName: [],
      selectDialog: false,
      moduleForm: {
        name: "",
        start_file_name: "",
        module_zip_url: "",
        module_zip_md5: ""
      },
      jsZip: new JsZip(),
      moduleuploadDialog: false
    };
  },
  beforeMount() {},
  mounted() {
    this.setSubTitle("支付模块管理");
    this.getAllPaymentModules();
  },
  filters: {
    tsToDate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    ...mapActions([]),
    deleteRow(row) {
      const { pay_module_id } = row;
      console.log("asasada", pay_module_id);
      this.$confirm("确定删除此模块?", "删除提示", {
        type: "danger",
        confirmButtonText: "确定删除",
        cancelButtonText: "取消删除"
      })
        .then(async () => {
          // alert("删除");
          try {
            await apiDeletePaymentModules([pay_module_id]);
            this.$message.success('删除成功');
            this.getAllPaymentModules();
          } catch (e) {
            console.log(e);
            this.$message.error('删除失败' + e.message);
          }
        })
        .catch();
    },
    copy(row) {
      this.$copyText(row.module_zip_url)
        .then(e => {
          this.$message.success("复制成功");
        })
        .catch(e => {
          console.log(e);
          this.$message.error("复制失败" + e);
        });
    },
    showUsing() {
      this.$message.error("开发中.. ");
    },
    edit() {
      return this.$message.error("开发中....");
      this.moduleuploadDialog = true;
    },
    changeStartFile() {
      if (this.exeName.length === 0) {
        this.$message.error("此zip包中没有.exe文件, 请检查");
      }

      if (this.exeName.length === 2) {
        this.$message.error("此zip包中只有一个.exe文件, 无需修改");
      }
      if (this.exeName.length > 1) {
        this.selectDialog = true;
      }
    },
    downLoad(row) {
      let url = row.module_zip_url;
      let name = row.name + ".zip";
      fileSaver.saveAs(url, name);
    },
    async getAllPaymentModules() {
      try {
        this.paymentsList = await apiGetAllPaymentModules();
        // console.log(res);
      } catch (e) {}
    },
    cancelUpload() {
      this.moduleForm = {
        name: "",
        start_file_name: "",
        module_zip_url: "",
        module_zip_md5: "",
        jsZip: new JsZip()
      };
      this.moduleuploadDialog = false;
      this.$refs["upload"].clearFiles();
    },
    async confirmUpload() {
      if (!this.moduleForm.module_zip_url) {
        return this.$message.error("模块zip未上传");
      }
      if (!this.moduleForm.name) {
        return this.$message.error("缺少name信息");
      }
      if (!this.moduleForm.start_file_name) {
        return this.$message.error("缺少入口文件");
      }
      if (!this.moduleForm.module_zip_md5) {
        return this.$message.error("缺少md5");
      }
      try {
        await apiAddPaymentModule(this.moduleForm);
        this.$message.warning("添加成功");
        this.cancelUpload();
        this.getAllPaymentModules();
      } catch (e) {
        this.$message.error("上传到服务器失败" + e.message);
      }
    },
    async computedMd5(file) {
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      let that = this;
      fileReader.onload = async e => {
        let md5key = md5(e.target.result);
        console.log(md5key);
        that.moduleForm.module_zip_md5 = md5key;
        // return md5key;
      };
    },
    chooseStartName(name) {
      this.moduleForm.start_file_name = name;
      this.selectDialog = false;
    },
    async handleBeforeUpload(file) {
      console.log(file);
      const jsZip = new JsZip();
      // let md5 = md5(file);
      this.computedMd5(file);
      jsZip
        .loadAsync(file)
        .then(file => {
          console.log(file);
          let { files } = file;
          let fileNames = Object.keys(files);
          this.exeName = fileNames.filter(a => {
            return a.search(/(.exe)$/) !== -1;
          });
          this.exeName = this.exeName.map(a => {
            return this.$_.last(a.split("/"));
          });
          if (this.exeName.length === 0) {
            this.$message.error("此zip包中无.exe执行文件, 请检查");
          } else if (this.exeName.length === 1) {
            this.moduleForm.start_file_name = this.exeName[0];
            this.$message.warning("此zip包只有一个.exe文件, 已默认为入口文件");
          } else {
            this.$message.warning("此zip包有多个.exe文件, 请选择入口文件");
            this.selectDialog = true;
          }
        })
        .catch(e => {
          console.log(e);
          this.$message.error("解压失败, 请上传zip格式");
        });
    },
    addPaymentModule() {},
    async modelUpload(options) {
      let file = options.file;
      let storeAs = new Date().getTime();
      console.log(file);
      const { url } = await aliOSSUpload(
        {
          // prefix: 'regionModels',
          bucket: "payment-modules",
          name: "paymentModule-" + storeAs
        },
        file
      );
      this.moduleForm.module_zip_url = url;
      console.log(url);
    }
  },
  computed: {
    ...mapGetters([]),
    tableConfig() {
      return [
        { prop: "_index", name: "#", width: 50 },
        { prop: "name", name: "模块名称", width: 400 },
        { prop: "_action", name: "添加时间", actionName: "add_date_slot" },
        { prop: "_action", name: "版本号", actionName: "version_slot" },
        { prop: "_action", name: "操作", actionName: "event_slot" }
      ];
    },
    modulesListByFilter() {
      let searchText = this.seachBox;
      let list = this.paymentsList;
      list = list.sort((a, b) => {
        return b.pay_module_update_ts - a.pay_module_update_ts;
      });
      return list.filter(a => {
        let res = pinyinMatch.match(a.name, searchText);
        return res.length > 0;
      });
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  .header-title {
    position: absolute;
    top: -90px;
    left: 200px;
    z-index: 1000;
  }
}
</style>
